import TextFieldValidation from "../../../components/UI/table/customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import React, {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import ButtonCreate from "../../../components/UI/button/ButtonCreate";
import {getFileExtension, getFileNameAndExtension} from "../../../utils/common/getFileExtension";
import DetailControllerService from "../../../API/details/customer/DetailControllerService";
import DetailControllerServiceOrganization from "../../../API/details/organization/DetailControllerServiceOrganization";
import Rotate90DegreesCwOutlinedIcon from '@mui/icons-material/Rotate90DegreesCwOutlined';
import Rotate90DegreesCcwOutlinedIcon from '@mui/icons-material/Rotate90DegreesCcwOutlined';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import StopOutlinedIcon from '@mui/icons-material/StopOutlined';
import DetailCanvas from "./DetailProcessing/Canvas/DetailCanvas";
import {Canvas} from "@react-three/fiber";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import {calcNewScale, INIT_SCALE_PREV_DETAIL} from "../../../utils/processing/calcNewScale";
import ExportTable from "../../common/ExportTable";
import Postprocessors from "../../common/settings/Postprocessors";
import ButtonAdd from "../../../components/UI/button/ButtonAdd";
import ButtonExit from "../../../components/UI/button/ButtonExit";

const DetailRotate = ({detailData, setModal, containerSize, description = true}) => {
    const refCanvas = useRef(null)
    const [params, setParams] = useState({
        scale: INIT_SCALE_PREV_DETAIL,
        corePosition: [0, 0, 0],
        length: detailData?.length,
        width: detailData?.width
    });

    useEffect(() => {
        if (refCanvas.current) {
            const length = detailData?.coordinatesSwapped ? detailData?.width : detailData?.length
            const width = detailData?.coordinatesSwapped ? detailData?.length : detailData?.width
            const scale = calcNewScale(refCanvas.current || {}, {
                length,
                width
            }, true, description ? 0.009 : 0.007)
            const scaleByRatio = window.devicePixelRatio < 0.45 ? scale * (window.devicePixelRatio ** 2) : window.devicePixelRatio < 0.6 ? scale * (window.devicePixelRatio ** 2.5) : window.devicePixelRatio < 1 ? scale * (window.devicePixelRatio ** 5) : window.devicePixelRatio < 1.3 ? scale / (window.devicePixelRatio ** 2) : window.devicePixelRatio < 1.4 ? scale / window.devicePixelRatio : scale
            const corePosition = [-(length / 2 * scaleByRatio), -(width / 2 * scaleByRatio), 0];

            setParams({scale: scaleByRatio, corePosition, length, width})
        }
    }, [refCanvas.current, detailData]);

    return <Box ref={refCanvas} onClick={() => setModal && setModal(true)} sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: containerSize.width,
        height: containerSize.height
    }}>
        <Canvas>
            <DetailCanvas
                reaOnly={true}
                position={params.corePosition}
                detailData={detailData}
                scale={params.scale}
                width={params.width}
                length={params.length}
            />
        </Canvas>

        {description && <Box sx={{height: 60, display: "flex", flexDirection: "column", alignItems: "center"}}>
            {detailData?.rotated &&
                <Typography
                    sx={{color: "rgb(248, 123, 14)"}}>Положение детали изменено</Typography>}
            {detailData?.coordinatesSwapped &&
                <Typography sx={{color: "rgb(248, 123, 14)"}}>Деталь повернута перпендикулярно</Typography>}
            {detailData?.mirrored && <Typography sx={{color: "rgb(248, 123, 14)"}}>Деталь отражена</Typography>}
        </Box>}
    </Box>
}

const ExportDetail = ({
                          orderId,
                          detailId,
                          position,
                          handleModalAlert,
                          setIsError,
                          organization,
                          requestsCuttingId,
                          all
                      }) => {
    const [detailData, setDetailData] = useState(null)
    const [isLoading, setIsLoading] = useState(true);
    const [selectedString, setSelectedString] = useState(null);
    const [rowsSelection, setRowsSelection] = useState([])
    const [modal, setModal] = useState(false)
    const [modalChoose, setModalChoose] = useState("")

    useEffect(() => {
        if (organization) {
            const api = requestsCuttingId ? DetailControllerServiceOrganization.getDetailByRequestsCuttingId(requestsCuttingId) : DetailControllerServiceOrganization.getDetail(detailId)
            api.then(function (response) {
                setDetailData(response.data)
                all ? setSelectedString(response.data[0]) : setSelectedString(response.data)
                setIsLoading(false)
            }).catch(handleModalAlert);
        } else {
            setIsLoading(false)
        }
    }, []);

    const handlerExport = (idPostprocessor, close) => {
        const api = all ? DetailControllerServiceOrganization.exportAllFiles(requestsCuttingId, idPostprocessor, modalChoose === "selected" && rowsSelection) : organization ? DetailControllerServiceOrganization.exportFile(detailId, idPostprocessor) : DetailControllerService.exportFile(orderId, detailId, idPostprocessor)
        api.then((response) => {
            const fileExtension = getFileExtension(response);
            const fileName = all ? getFileNameAndExtension(response.headers['content-disposition']) : `${position}.${fileExtension}`
            const url = window.URL.createObjectURL(new Blob([response.data], {type: fileExtension}));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            setIsError && setIsError(false);
            close()
            setRowsSelection([])
            handleModalAlert(all ? "Детали экспортированы" : "Детали экспортирована", 'success')
        })
            .catch((error) => {
                handleModalAlert(error)
            })
    }
    const handleClockwise = (type) => {
        const api = type === "counterClockwise" ? DetailControllerServiceOrganization.rotateCounterClockwise :
            type === "reset" ? DetailControllerServiceOrganization.resetRotate :
                type === "mirrorVertically" ? DetailControllerServiceOrganization.mirrorVertically :
                    type === "mirrorHorizontally" ? DetailControllerServiceOrganization.mirrorHorizontally :
                        DetailControllerServiceOrganization.rotateClockwise
        api(selectedString.id).then(function (response) {
            all ? setDetailData(prev => prev.map(el => el.id === response.data.id ? response.data : el)) : setDetailData(response.data)
            setSelectedString(response.data)
            handleModalAlert("Данные изменены", 'success')
        }).catch(handleModalAlert);
    }
    return isLoading ?
        <Box sx={{
            height: `calc(100vh - 570px)`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }}>
            <CircularProgress disableShrink/>
        </Box> : <Box sx={{display: "flex", flexDirection: "column", gap: "10px"}}>
            <Box sx={{display: "flex", gap: "10px"}}>
                <Box>
                    <Box sx={{display: "flex", justifyContent: all ? "space-between" : "flex-start", gap: "20px"}}>
                        <Box sx={{display: "flex",}}>
                            <Tooltip title={'Поворот против часовой стрелки на 90 градусов'}>
                                <Button onClick={() => handleClockwise("counterClockwise")}>
                                    <Rotate90DegreesCcwOutlinedIcon/>
                                </Button>
                            </Tooltip>
                            <Tooltip title={'Поворот по часовой стрелке на 90 градусов'}>
                                <Button onClick={() => handleClockwise("clockwise")}>
                                    <Rotate90DegreesCwOutlinedIcon/>
                                </Button>
                            </Tooltip>
                            <Tooltip title={'Вернутся к начальному положению'}>
                                <Button onClick={() => handleClockwise("reset")}>
                                    <StopOutlinedIcon/>
                                </Button>
                            </Tooltip>
                            <Tooltip title={'Отразить по горизонтали'}>
                                <Button onClick={() => handleClockwise("mirrorHorizontally")}>
                                    <CompareArrowsIcon/>
                                </Button>
                            </Tooltip>
                            <Tooltip title={'Отразить по вертикали'}>
                                <Button onClick={() => handleClockwise("mirrorVertically")}>
                                    <CompareArrowsIcon sx={{rotate: "90deg"}}/>
                                </Button>
                            </Tooltip>
                        </Box>
                    </Box>
                    {all ? <ExportTable data={detailData}
                                        selectedString={selectedString}
                                        setSelectedString={setSelectedString}
                                        rowSelection={rowsSelection}
                                        setRowSelection={setRowsSelection}/> :
                        <DetailRotate
                            containerSize={{
                                width: `calc(100vw - 50px)`,
                                height: `calc(100vh - 410px)`
                            }}
                            detailData={selectedString}/>
                    }
                    <Box sx={{display: "flex", gap: "10px"}}>
                        <ButtonCreate icon={false}
                                      text={all ? "Экспортировать все детали" : "Экспортировать деталь"}
                                      width={all ? 225 : 200}
                                      onClick={() => setModalChoose("all")}/>
                        {rowsSelection.length > 0 &&
                            <ButtonCreate icon={false} text={"Экспортировать выбранные детали"} width={285}
                                          onClick={() => setModalChoose("selected")}/>}
                    </Box>
                </Box>
                {all && selectedString && <DetailRotate
                    detailData={selectedString}
                    setModal={setModal}
                    containerSize={{
                        width: `calc(100vw - 900px)`,
                        height: `calc(100vh - 385px)`
                    }}/>}
            </Box>
            <ModalBigDetail modal={modal} setModal={setModal} selectedString={selectedString}/>
            <ModalChoose modal={modalChoose} handleClose={() => setModalChoose("")} handleSubmit={handlerExport}/>
        </Box>
}

const ModalBigDetail = ({modal, setModal, selectedString,}) => {
    return (
        <Dialog open={modal} onClose={() => setModal(false)} PaperProps={{
            style: {
                minWidth: `90vw`,
                borderRadius: 8,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
        }}>
            <DetailRotate
                description={false}
                detailData={selectedString}
                containerSize={{
                    width: `calc(90vw - 50px)`,
                    height: `calc(90vh - 80px)`
                }}/>

            <DialogActions sx={{width: '97%', p: '1.25rem'}}>
                <Button onClick={() => setModal(false)}>Выход</Button>
            </DialogActions>
        </Dialog>
    )
}
const ModalChoose = ({modal, handleClose, handleSubmit}) => {
    const [selectedString, setSelectedString] = useState({})
    const close = () => {
        setSelectedString({})
        handleClose()
    }
    return (
        <Dialog open={modal} PaperProps={{
            style: {
                minWidth: "700px"
            }
        }}>
            <DialogTitle textAlign="center">Выберите постпроцессор</DialogTitle>
            <DialogContent>
                <Postprocessors isModal={true} selectedString={selectedString} setSelectedString={setSelectedString}/>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={close}/>
                <ButtonAdd
                    text={"Выбрать"}
                    onClick={() => handleSubmit(selectedString?.id, close)}
                    disabled={!selectedString?.id}
                />
            </DialogActions>
        </Dialog>
    )
}
export default ExportDetail;